/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cron_Daily_9Inputs */

const cs_cron_daily_9 = /** @type {(inputs: Cron_Daily_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denně v 9:00`)
};

const en_cron_daily_9 = /** @type {(inputs: Cron_Daily_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily at 9:00`)
};

/**
* | output |
* | --- |
* | "Daily at 9:00" |
*
* @param {Cron_Daily_9Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const cron_daily_9 = /** @type {((inputs?: Cron_Daily_9Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cron_Daily_9Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cron_daily_9(inputs)
	return cs_cron_daily_9(inputs)
});